import { AccountCircleRounded as AccountCircleRoundedIcon } from '@mui/icons-material';

const User = (): JSX.Element => <AccountCircleRoundedIcon fontSize="inherit" />;

export default User;
